import StudentTitle from "./Student/StudentTitle";
import ClassTitle from "./Class/ClassTitle";
import ClassRow from "./Class/ClassRow";
import StudentRow from "./Student/StudentRow";
import TeacherTitle from "./Teachers/TeacherTitle";
import TeacherRow from "./Teachers/TeacherRow";

import styles from "./style.module.css";
import { useContext } from "react";
import { userContext } from "../../../contextAdmin/Admin/User";

export default function NewTable({ currList, typ }) {


  const { user } = useContext(userContext)
  const
    flagClass = typ === "class",
    flagStudent = typ === "student",
    flagTeacher = (!flagClass && !flagStudent)

  return (
    <div className={`${styles["table-container"]} ${styles.list}`}>

      {flagClass ? (<ClassTitle />)
        :
        flagStudent ? (<StudentTitle />)
          :
          flagTeacher ? (<TeacherTitle />)
            : ("")}

      {currList.sort((a, b) => a.id.localeCompare(b.id)).map(listItem => {
        console.log("🚀 ~ NewTable ~ listItem:", listItem.id)

        if (flagClass)
          return (
            <ClassRow key={listItem.classroomId} value={listItem} />)

        if (flagStudent) {
          return (<StudentRow key={listItem.id} value={listItem} />)
        }

        if (flagTeacher
          // && user._id !== listItem._id
        )
          return (<TeacherRow key={listItem.id} value={listItem} />)

        else
          return ""
      })}
    </div>
  );
}
